"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBuyer = exports.getDeadline = exports.getItemId = exports.getName = void 0;
const tender_1 = require("../../tender");
const TenderUtils = __importStar(require("./tender"));
const ManualBidItemUtils = __importStar(require("./../matching/manual-bid-item"));
const UserMailUtils = __importStar(require("./../mercury/user-mail"));
function getName(bid) {
    var _a, _b;
    switch (bid.itemType) {
        case tender_1.BidItemType.Procurement:
            return TenderUtils.getName(bid.item);
        case tender_1.BidItemType.CallOff:
            return (_a = bid.item.subject) !== null && _a !== void 0 ? _a : undefined;
        case tender_1.BidItemType.Manual:
            return (_b = bid.item.name) !== null && _b !== void 0 ? _b : undefined;
        default:
            throw Error(`Invalid itemType value provided: ${bid.itemType}`);
    }
}
exports.getName = getName;
function getItemId(bid) {
    var _a, _b;
    return bid.itemType === tender_1.BidItemType.CallOff
        ? (_a = bid.item.mailId) !== null && _a !== void 0 ? _a : undefined
        : (_b = bid.item.id) !== null && _b !== void 0 ? _b : undefined;
}
exports.getItemId = getItemId;
function getDeadline(bid) {
    switch (bid.itemType) {
        case tender_1.BidItemType.Procurement:
            return TenderUtils.getDeadline(bid.item);
        case tender_1.BidItemType.CallOff:
            return UserMailUtils.getDeadline(bid.item);
        case tender_1.BidItemType.Manual:
            return ManualBidItemUtils.getDeadline(bid.item);
        default:
            throw Error(`Invalid itemType value provided: ${bid.itemType}`);
    }
}
exports.getDeadline = getDeadline;
function getBuyer(bid) {
    switch (bid.itemType) {
        case tender_1.BidItemType.Procurement:
            return TenderUtils.getBuyer(bid.item);
        case tender_1.BidItemType.CallOff:
            return UserMailUtils.getBuyer(bid.item);
        case tender_1.BidItemType.Manual:
            return ManualBidItemUtils.getBuyer(bid.item);
        default:
            throw Error(`Invalid itemType value provided: ${bid.itemType}`);
    }
}
exports.getBuyer = getBuyer;
